/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl,UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
@Component({
  selector: 'update-markup.component',
  templateUrl: './update-markup.component.html',
  styleUrls: ['./update-markup.component.scss']
})
export class UpdateMarkupComponent implements OnInit {
  markupType: string = 'FLAT';
  markupValue: number = 0;
  companyConfig: any = null;
  stepValue: number = 1;
  formSubmitted: boolean = false;
  constructor(public dialogRef: MatDialogRef<UpdateMarkupComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public utilityService: UtilityService,
              private formBuilder: UntypedFormBuilder){
      this.companyConfig = this.utilityService.companyConfig;
      this.markupType = this.companyConfig?.product?.default_markup_type ?? 'FLAT';
  }
  ngOnInit(): void {}

  updateMarkup(): void{
    this.formSubmitted = true;
    if(!this.utilityService.isEmptyOrUndefined(this.markupType) && !this.utilityService.isEmptyOrUndefined(this.markupValue)){
      const payload = {
        markupType: this.markupType,
        markupValue: this.markupValue
      }
      this.dialogRef.close(payload);
    }
  }

}
